import { useState, useEffect, useMemo } from 'react';
import { TextInput, Icon } from '@burna/monster-design-system';
import axios from 'axios';
import styles from './index.module.scss';
import { APIName } from 'config';

function Captcha({ refreshCaptcha, onCaptchaChange, isSubmitted, disabled }) {
  const [captchaCode, setCaptchaCode] = useState('');
  const [captchaImage, setCaptchaImage] = useState('');

  useEffect(() => {
    fetchCaptcha();
  }, [refreshCaptcha]);

  const captchaErrors = useMemo(() => {
    if (!captchaCode) {
      return ['Enter captcha code'];
    }
    return [];
  }, [captchaCode]);

  const fetchCaptcha = () => {
    setCaptchaCode('');
    axios.get(`/api/${APIName}/captcha`)
      .then(res => {
        setCaptchaImage(res.data);
      })
      .catch(err => {
        console.error('Error fetching captcha:', err);
      });
  };

  const handleCaptchaChange = (e) => {
    setCaptchaCode(e.target.value);
    onCaptchaChange(e.target.value);
  };

  return (
    <div className={styles.container}>
      <div className={styles.captchaWrapper}>
        {captchaImage ? (
          <div dangerouslySetInnerHTML={{ __html: captchaImage }} />
        ) : (
          <img src="/images/default-captcha.png" alt="Captcha not available" />
        )}
        <span className={styles.iconWrapper} onClick={fetchCaptcha}>
          <Icon className={styles.icon} type="refresh-cw" />
        </span>
      </div>
      <TextInput
        title="Captcha"
        placeholder="Enter Captcha Code"
        value={captchaCode}
        onChange={handleCaptchaChange}
        disabled={disabled}
        errorMessages={captchaErrors}
        hasError={isSubmitted &&  captchaErrors.length > 0}
      />
    </div>
  );
}

export default Captcha;
